exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#final-result.fixed {\n  background-color: #fafaff;\n  position: fixed;\n  top: 0;\n  width: 100%;\n  left: 0;\n  z-index: 1000;\n  padding-top: 15px;\n  padding-bottom: 15px;\n}\n#final-result.fixed::after {\n  content: \"\";\n}", ""]);

// exports
